// Central content + media for Salvatore Castelli Photography
export const BRAND = {
  name: "Salvatore Castelli",
  suffix: "Photography",
  email: "salvatorecastelli70@gmail.com",
  phone: "3899361021",
  phoneIntl: "+393899361021",
  instagram: "https://www.instagram.com/sansasanto95_ph/",
  instagramHandle: "@sansasanto95_ph",
  base: "Faleria, Viterbo",
  areas: ["Faleria", "Viterbo", "Tuscia Viterbese", "Roma"],
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/l0ii3i9c_DSC_0221-2.webp",
  wedding: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/o0yqwdj2_DSC_0112.webp",
  birthday: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/unqf35or_DSC00135.webp",
  landscape: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/cd34l66x_DSC_0213.webp",
  portrait: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/s1asfy7z_8f19faf4da161112fd31c20787092f18~tplv-tiktokx-cropcenter_1080_1080.jpeg",
  corporate: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/qmmqg896_DSC08214.webp",
  servicesBanner: "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/jjycet5e_DSC00751.webp",
  gallery: [
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/m5meprq2_DSC00656-2.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/l0ii3i9c_DSC_0221-2.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/o0yqwdj2_DSC_0112.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/ololz3dm_DSC_0044.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/cd34l66x_DSC_0213.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/4azaqwsf_DSC00752-2.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/2g9oc73y_DSC00373-2.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/v9eyxogp_DSC07874.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/unqf35or_DSC00135.webp",
    "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/rfpnzgr5_DSC03046-2.webp",
  ],
};

export const GOOGLE = {
  rating: "5.0",
  count: 27,
  url: "https://share.google/m1qadjJ5VejgEzTqL",
};

export const TESTIMONIALS = [
  { name: "Rebecca Valente", role: "Festa di compleanno · 2 mesi fa", text: "Ho contattato Salvatore per la festa di mia figlia e siamo rimasti veramente contenti di tutto! Professionista serio e soprattutto molto bravo a saper cogliere tutti i momenti più belli della serata! Foto stupende. Consigliatissimo!" },
  { name: "Giorgia Sciarra", role: "Festa di 18 anni · 4 mesi fa", text: "Ho contattato Salvatore per il 18° di mio figlio… sono rimasta soddisfattissima. Ha fatto molte foto bellissime. Lo consiglio, perché trovo sia una persona molto professionale." },
  { name: "Ivano Lattanzi", role: "Recensione Google · 8 mesi fa", text: "Professionale, discreto e sempre attento a cogliere i momenti più belli senza mai essere invadente. Le foto sono stupende, piene di emozione e naturalezza. Consigliatissimo." },
  { name: "Eduard Raduna", role: "Recensione Google · 11 mesi fa", text: "Un ragazzo giovane, educato e davvero appassionato. Ha un occhio incredibile per le foto e i video, cura ogni dettaglio con professionalità e creatività. Una persona affidabile e sempre disponibile, con un grande futuro davanti! Consigliatissimo!" },
  { name: "Constantin Dima", role: "Evento · 11 mesi fa", text: "Grazie mille, foto bellissime! Salvatore molto professionale, è riuscito a riprendere molto bene tutti i bei momenti della serata! Soddisfattissimi!" },
];
